document.addEventListener("alpine:init", () => {
  Alpine.data("Localization_CountrySelector", ({ options = [],value }) => ({
    options,
    value,
    init() {
      this.$nextTick(() => {
        let choices = new Choices(this.$refs.select);
        let refreshChoices = () => {
          let selection = this.multiple ? this.value : [this.value];
          choices.clearStore();
          choices.setChoices(
            this.options.map(({ value, label }) => ({
              value,
              label,
              selected: selection.includes(value),
            }))
          );
        };
        refreshChoices();
        this.$refs.select.addEventListener("change", () => {
          this.value = choices.getValue(true);
        });

        this.$watch("value", () => refreshChoices());
        this.$watch("options", () => refreshChoices());
      });
    },
  }));
});
